import posthog from 'posthog-js'

/** Init PostHog once at app boot. No-op when key missing or in development. */
export function initPostHog(): void {
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key || import.meta.env.MODE === 'development') return

  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_API_HOST || 'https://eu.i.posthog.com',
    ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
    defaults: '2026-05-30',
  })
}

export { posthog }
